import React from "react";
import Dialog from "../../../../shared/dialog";
import "./index.scss";
import {
  schemaNoUrl,
  schemaWithUrl,
  schemaValidateLinkYoutube,
} from "./validate";
import {
  COUNTER_TABLE,
  MEDIA_TYPE,
  STANDARD_TABLE,
  TABLE_TYPE_MAP,
} from "../../../../../constants/app";
import MyButton from "../../../../shared/buttons/primary";
import { cloneDeep } from "lodash";
import FormInput from "../../../../shared/form-input";

const TableDialog = (props) => {
  const { detailData, showByType, onclose } = props;
  const isCreate = showByType === "create";
  const [formCreate, setFormCreate] = React.useState({
    name: "",
    detail: "",
    seats: "",
    shop: window.store.getState().auth.user.id,
    media_type: MEDIA_TYPE.IMAGE,
    image: "",
    table_type: STANDARD_TABLE,
    min_seats: null,
    extra_seats: null,
  });
  const [formMessage, setFormMessage] = React.useState([]);
  const [imageTypeError, setImageTypeError] = React.useState("");
  const [imgBlob, setImgBlob] = React.useState("");
  const [disableBtn, setDisableBtn] = React.useState(false);
  const [youtubePath, setYoutubePath] = React.useState("");

  React.useEffect(() => {
    if (!isCreate && detailData) {
      let formInit = {};
      const fields = [
        "name",
        "detail",
        "seats",
        "shop",
        "media_type",
        "image",
        "table_type",
        "min_seats",
        "extra_seats",
      ];
      fields.forEach((field) => {
        formInit[field] = detailData[field] || "";
      });
      setFormCreate(formInit);
    }
  }, [detailData, isCreate]);

  const handleChangeForm = React.useCallback(
    (name, value) => {
      setFormCreate({
        ...formCreate,
        [name]: value,
      });
    },
    [formCreate]
  );

  const onCloseRequest = (data) => {
    onclose(data);
  };

  const removeImage = React.useCallback(() => {
    if (imgBlob) setImgBlob("");

    setFormCreate({
      ...formCreate,
      image: "",
    });
  }, [formCreate, imgBlob]);

  const onSelectImage = (e) => {
    setImageTypeError("");
    let image = e.target.files[0];
    const { isValid, error } = window.utils.validateImage(image);

    if (error) {
      setImageTypeError(error);
    }

    if (!isValid) {
      return;
    }
    image.path = URL.createObjectURL(e.target.files[0]);
    setImgBlob(image);
  };

  const onChangeRadio = React.useCallback(
    (e) => {
      const { value } = e.target;
      const isImage = value === MEDIA_TYPE.IMAGE;
      setFormCreate({
        ...formCreate,
        image: isImage ? imgBlob?.path : youtubePath,
        media_type: value,
      });
    },
    [formCreate]
  );

  const handleCreateTable = async () => {
    setDisableBtn(true);
    const isImage = formCreate.media_type === MEDIA_TYPE.IMAGE;
    const validate = (isImage ? schemaNoUrl : schemaWithUrl).validate(
      formCreate
    );
    const validateLabels = ["name", "seats", "detail"];
    if (!isImage && formCreate.image) {
      validateLabels.push(MEDIA_TYPE.IMAGE);
    }
    let errors;
    errors = validate.error.details.filter((item) =>
      validateLabels.includes(item.context.label)
    );

    errors = errors.map((item) => {
      return {
        name: item.context.label,
        message: item.message,
      };
    });
    if (formCreate.table_type === STANDARD_TABLE) {
      if (!formCreate.min_seats) {
        errors.push({
          name: "min_seats",
          message: "予約可能最小人数を入力してください。",
        });
      } else if (formCreate.min_seats > formCreate.seats) {
        errors.push({
          name: "min_seats",
          message: "最小座席数は総座席数より大きくすることはできません。",
        });
      }

      if (formCreate.extra_seats && formCreate.extra_seats > formCreate.seats) {
        errors.push({
          name: "extra_seats",
          message: "追加座席の数は合計座席数を超えてはなりません。",
        });
      }
    }

    if (errors.length) {
      setFormMessage(errors);
      setDisableBtn(false);
      return;
    }

    const formSubmit = cloneDeep(formCreate);
    const isMediaFile = isImage && typeof imgBlob === "object";

    if (isMediaFile) {
      const link = (await window.utils.uploadFile(imgBlob)).data.link;
      formSubmit.image = link;
    }

    if (isCreate) {
      handleCreate(formSubmit);
    } else {
      handleUpdate(formSubmit);
    }
  };

  const handleCreate = (formSubmit) => {
    window
      .axios({
        url: `table/`,
        method: "post",
        data: formSubmit,
      })
      .then((result) => {
        onCloseRequest(result.data);
      });
  };

  const handleUpdate = (formSubmit) => {
    window
      .axios({
        url: `table/${detailData.id}/`,
        method: "put",
        data: formSubmit,
      })
      .then((result) => {
        onCloseRequest(result.data);
      });
  };

  const isImage = React.useMemo(() => {
    return formCreate.media_type === MEDIA_TYPE.IMAGE;
  }, [formCreate]);

  const isYoutube = React.useMemo(() => {
    return formCreate.media_type === MEDIA_TYPE.YOUTUBE;
  }, [formCreate]);

  const isStandardTable = React.useMemo(() => {
    return formCreate.table_type === STANDARD_TABLE;
  }, [formCreate]);

  const isCounterTable = React.useMemo(() => {
    return formCreate.table_type === COUNTER_TABLE;
  }, [formCreate]);

  const previewImage = (isShow) => {
    if (!isShow) return null;
    const path = imgBlob?.path || formCreate.image;
    return (
      <figure className="image-preview">
        <span className="material-icons" onClick={removeImage}>
          highlight_off
        </span>
        <img src={path} alt={"cippo"}></img>
      </figure>
    );
  };

  const renderSelectImage = () => {
    const path = imgBlob || formCreate.image;
    const showPreview = isImage && path;
    return (
      <>
        <div className="btn-wrapper">
          <div
            className="edit-button"
            onClick={() => {
              document.getElementById("create-menu-upload").click();
            }}
          >
            画像をアップロードする
          </div>
          <input
            type="file"
            id="create-menu-upload"
            hidden
            accept="image/*"
            onClick={(e) => {
              e.target.value = "";
            }}
            onChange={onSelectImage}
          />
        </div>
        {previewImage(showPreview)}
        {imageTypeError && (
          <p className="error-text auto-hide">{imageTypeError}</p>
        )}
      </>
    );
  };

  const handleChangeYoutubeInput = (e) => {
    const { value } = e.target;
    const { error } = schemaValidateLinkYoutube.validate({
      image: value,
    });

    if (error) {
      const errorMsg = cloneDeep(formMessage);
      const index = errorMsg.findIndex((item) => item.name === e.target.name);
      if (index !== -1) {
        errorMsg.splice(index, 1);
      }

      setFormMessage([
        ...formMessage,
        {
          message: error.details[0].message,
          name: "image",
        },
      ]);
    }
    setFormCreate({
      ...formCreate,
      image: value,
    });
    setYoutubePath(value);
  };

  const previewYoutube = (isShow) => {
    if (!isShow) return null;
    const path = youtubePath || formCreate.image;
    return (
      <figure
        style={{
          width: "200px",
          height: "200px",
          marginTop: "1rem",
        }}
      >
        <img
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          src={`https://img.youtube.com/vi/${
            path.match(
              //eslint-disable-next-line
              /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/
            )?.[1]
          }/0.jpg`}
          alt="thumbnail"
        />
      </figure>
    );
  };

  const renderYoutubePath = () => {
    const errorMessage = getFormMessage("image");
    const previewPath = youtubePath || formCreate.image;
    const showPreview = isYoutube && previewPath && !errorMessage;
    return (
      <>
        <input
          className="form-control price-input"
          value={isCreate ? youtubePath : formCreate.image}
          onChange={handleChangeYoutubeInput}
          placeholder="YOUTUBE リンク"
          onBlur={validateOnBlur}
          name="image"
        />
        {previewYoutube(showPreview)}
        {errorMessage}
      </>
    );
  };

  const getFormMessage = React.useCallback(
    (name) => {
      const error = formMessage.find((item) => item.name === name);
      if (!error) return null;
      return <p className="error-text">{error.message}</p>;
    },
    [formMessage]
  );

  const validateOnBlur = (e) => {
    const { name, value } = e.target;
    const isImageName = name === "image";
    if (name === "image" && !value) {
      setFormMessage(formMessage.filter((item) => item.name !== name));
      return;
    }
    let validateObject = isImageName ? schemaWithUrl : schemaNoUrl;
    const errorList = validateObject.validate({
      [name]: value,
    }).error.details;

    const error = errorList.find((item) => item.context.label === name);
    let errorMsg = cloneDeep(formMessage);

    if (name === "min_seats") {
      if (!value) {
        errorMsg.push({
          name: name,
          message: "予約可能最小人数を入力してください。",
        });
      } else if (value > formCreate.seats) {
        errorMsg.push({
          name: name,
          message: "最小座席数は総座席数より大きくすることはできません。",
        });
      } else {
        errorMsg = errorMsg.filter((message) => message.name !== name);
      }
    } else if (name === "extra_seats") {
      if (value && value > formCreate.seats) {
        errorMsg.push({
          name: name,
          message: "追加座席の数は合計座席数を超えてはなりません。",
        });
      } else {
        errorMsg = errorMsg.filter((message) => message.name !== name);
      }
    } else {
      if (!error) {
        const errorIdx = errorMsg.findIndex((error) => error.name === name);
        if (errorIdx !== -1) {
          errorMsg.splice(errorIdx, 1);
        }
      } else {
        const item = errorMsg.find((item) => item.name === error.context.label);

        if (!item) {
          errorMsg.push({
            name: name,
            message: error.message,
          });
        } else {
          errorMsg = errorMsg.map((item) => {
            if (item.name === error.context.label) {
              return {
                name: name,
                message: error.message,
              };
            }

            return item;
          });
        }
      }
    }

    setFormMessage(errorMsg);
  };

  const renderSeat = (label, name, required = true) => {
    return (
      <div className={`booking-form__row ${required ? "required" : ""}`}>
        <div className="booking-form__label">
          <label className="form-label user-select-none">{label}</label>
        </div>
        <div className="booking-form__control">
          <input
            type="number"
            className="form-control"
            placeholder={label}
            inputMode="decimal"
            onBlur={validateOnBlur}
            value={formCreate[name] || ""}
            name={name}
            maxLength="10"
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            }}
            onChange={(e) => {
              const { value } = e.target;
              if (String(value).length > 10) return;
              handleChangeForm(name, Number(value) || null);
            }}
          />
          {required && getFormMessage(name)}
        </div>
      </div>
    );
  };

  const renderOtherSeatsByTableType = () => {
    if (isCounterTable) return null;
    const minSeat = renderSeat("予約可能最小人数", "min_seats");
    const extraSeat = renderSeat("補助イス数", "extra_seats");
    return (
      <>
        {minSeat} {extraSeat}
      </>
    );
  };

  return (
    <Dialog
      id="menu-dialog"
      className={"booking-dialog menu-dialog"}
      title={isCreate ? "追加" : "編集"}
      isShow={!!showByType}
      onCloseRequest={() => onCloseRequest({})}
      closeOnOverlayClick={false}
    >
      <div className="booking-form__row required">
        <div className="booking-form__label">
          <label className="form-label user-select-none">座席タイプ</label>
        </div>
        <div className="booking-form__control form-image">
          <div className="radio-wrapper">
            <input
              type="radio"
              name="table-type"
              id="standard-table-radio"
              value={STANDARD_TABLE}
              checked={isStandardTable}
              className="me-2"
              onChange={(e) => {
                const { value } = e.target;
                handleChangeForm("table_type", value);
              }}
            />
            <label
              htmlFor="standard-table-radio"
              className="form-check-label me-5"
            >
              {TABLE_TYPE_MAP[STANDARD_TABLE]}
            </label>
            <input
              type="radio"
              name="table-type"
              id="counter-table-radio"
              value={COUNTER_TABLE}
              checked={isCounterTable}
              className="me-2"
              onChange={(e) => {
                const { value } = e.target;
                setFormCreate({
                  ...formCreate,
                  table_type: value,
                  min_seats: null,
                  extra_seats: null,
                });
              }}
            />
            <label
              htmlFor="counter-table-radio"
              className="form-check-label me-5"
            >
              {TABLE_TYPE_MAP[COUNTER_TABLE]}
            </label>
          </div>
        </div>
      </div>
      <div className="booking-form__row required">
        <div className="booking-form__label">
          <label className="form-label user-select-none">座席名</label>
        </div>
        <div className="booking-form__control">
          <FormInput
            className="form-control resize-none"
            onChange={(value) => {
              handleChangeForm("name", value);
            }}
            placeholder="座席名"
            inputMode="decimal"
            value={formCreate.name}
            onBlur={validateOnBlur}
            name="name"
            maxLength="50"
            showCount
          />
          {getFormMessage("name")}
        </div>
      </div>
      <div className="booking-form__row required">
        <div className="booking-form__label">
          <label htmlFor="customerNote" className="form-label user-select-none">
            備考
          </label>
        </div>
        <div className="booking-form__control">
          <FormInput
            className="form-control resize-none"
            rows="3"
            value={formCreate.detail}
            onBlur={validateOnBlur}
            name="detail"
            maxLength="200"
            placeholder="備考"
            onChange={(value) => {
              handleChangeForm("detail", value);
            }}
            inputType="textarea"
            showCount
          />
          {getFormMessage("detail")}
        </div>
      </div>
      {renderSeat("席数", "seats")}
      {renderOtherSeatsByTableType()}
      <div className="booking-form__row">
        <div className="booking-form__label">
          <label className="form-label user-select-none">
            写真・YOUTUBEリンク
          </label>
        </div>
        <div className="booking-form__control form-image">
          <div className="mb-3 radio-wrapper">
            <input
              type="radio"
              name="radio"
              id="image-radio"
              value={MEDIA_TYPE.IMAGE}
              checked={isImage}
              className="me-2"
              onChange={(e) => onChangeRadio(e)}
            />
            <label htmlFor="image-radio" className="form-check-label me-5">
              写真
            </label>
            <input
              type="radio"
              name="radio"
              value={MEDIA_TYPE.YOUTUBE}
              id="youtube-radio"
              checked={isYoutube}
              className="me-2"
              onChange={(e) => onChangeRadio(e)}
            />
            <label htmlFor="youtube-radio" className="form-check-label">
              YOUTUBE リンク
            </label>
          </div>
          <div>
            {isImage && renderSelectImage()}
            {isYoutube && renderYoutubePath()}
          </div>
        </div>
      </div>
      <div className="booking-form__btns">
        <MyButton
          myVariant="cancel"
          disabled={disableBtn}
          onClick={() => onCloseRequest({})}
        >
          キャンセル
        </MyButton>
        <MyButton
          myVariant="create"
          isLoading={disableBtn}
          onClick={handleCreateTable}
        >
          保存
        </MyButton>
      </div>
    </Dialog>
  );
};

export default TableDialog;
